import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <Toaster position="top-center" toastOptions={{
        style: { background: "#F5F0E6", color: "#2C2621", border: "1px solid #E8DCC8", fontFamily: "Outfit,sans-serif" }
      }}/>
      <Header/>
      <main className="flex-1"><Outlet/></main>
      <Footer/>
    </div>
  );
}
